<template>
  <div class="auth-container d--f jc--c ai--c">
    <AppCard class="pa-30px confirm-card">
      <div class="text-center">
        <h2 class="confirm-title">✅ Account Confirmed!</h2>
        <p class="confirm-description">Your email address has been successfully confirmed.</p>
        <p class="redirect-message">Logging you in and redirecting to your dashboard...</p>
      </div>
    </AppCard>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { AppCard } from "@/components/ui";

import { showToast } from "@/utilities/toast";
import AuthApi from "@/api/auth";

const route = useRoute();
const router = useRouter();

onMounted(async () => {
  const response = await AuthApi.confirmAccount(route.query.confirmation_token);

  response.data.error ? showToast(response.data.error, { type: "error" }) : router.push({ name: "reports" });
});
</script>

<style lang="scss" scoped>
.auth-container {
  position: relative;
  min-height: 100vh;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("@/assets/images/auth-background.jpg") no-repeat center;
    background-size: cover;
    filter: blur(10px);
    z-index: -1;
  }
}

.confirm-card {
  max-width: 500px;
}

.confirm-title {
  color: $color-green;
  margin-bottom: 1rem;
  font-size: 1.75rem;
  font-weight: 600;
}

.confirm-description {
  color: $color-grey-6;
  margin-bottom: 1rem;
  font-size: 1rem;
}

.redirect-message {
  color: $color-primary;
  font-style: italic;
  margin-top: 1rem;
  font-weight: 500;
  font-size: 0.9rem;
}
</style>
